/**
 * Multi-domena SSO plant (client-only).
 *
 * Po in-place loginie "sadzi" master-sesję na hoście backendu (IdP) przez
 * top-level POST form na `/ISSO`. Top-level nawigacja jest WYMAGANA - master
 * cookie musi być ustawione first-party na hoście backendu; fetch/iframe = kontekst
 * third-party (Set-Cookie blokowane przez przeglądarki). Backend konsumuje ticket,
 * ustawia master cookie i 303 redirect z powrotem na `continue` (bieżąca strona) -
 * użytkownik wraca zalogowany (cookie frontendu ustawione już w /api/iiapi/login).
 *
 * Dzięki temu KOLEJNE domeny CMS dostają silent SSO (probe -> /ISSO/authorize ->
 * ticket -> /api/sso/callback).
 *
 * @param action Adres endpointu, np. `https://backend/ISSO`
 * @param ticket Jednorazowy `plant_ticket` z odpowiedzi loginu
 * @param continueUrl Dokąd backend ma wrócić po zasadzeniu - MUSI być absolutnym
 *        URL frontendu (plant biegnie na hoście backendu; relative path wróciłby
 *        na backend). Domyślnie bieżąca strona (`window.location.href`).
 * @returns `true` gdy zainicjowano nawigację (caller pomija własny refresh)
 */
export function submitSsoPlant(
  action: string,
  ticket: string,
  continueUrl?: string,
): boolean {
  if (typeof window === "undefined" || !action || !ticket) return false;

  const form = document.createElement("form");
  form.method = "POST";
  form.action = action;
  form.style.display = "none";

  const addHidden = (name: string, value: string) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  addHidden("sso_ticket", ticket);
  addHidden("continue", continueUrl || window.location.href);

  document.body.appendChild(form);
  form.submit();
  return true;
}
